import React, { useEffect, useState } from "react";
import { Form, ListGroup, Table } from "react-bootstrap";
import { useParams } from "react-router";
import { FaEdit, FaRegPlusSquare, FaTrash } from "react-icons/fa";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import Pagination from "../../Pagination";
import AddFormLibrary from "./AddFormLibrary";
import UseToggle from "../../../Hooks/UseToggle";
import UpdateFormTemplate from "./UpdateFormTemplate";
import Swal from "sweetalert2";
import Moment from "react-moment";
import ImportFormColumnData from "./ImportFormColumnData";

const FormDataManagement = ({ onMouseDown, tableRef }) => {
  const toggles = UseToggle();
  const { studyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [libraryList, setFormLibraryList] = useState([]);
  const [formId, setFormId] = useState("");
  const [columnBase, setColumnBase] = useState("label")

  const [libraryTemplate, setFormLibraryTemplate] = useState([]);
  const [loader, setLoader] = useState(false);

  const [studyDataEntry, setStudyDataEntry] = useState([]);
  const [studyDataEntryCount, setStudyDataEntryCount] = useState(0);
  const [templateData, setTemplateData] = useState(null);
  const [dataLoader, setDataLoader] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(studyDataEntryCount / itemsPerPage);

  const getStudyFormLibraryData = async () => {
    try {
      setLoading(true);
      const data = await cdiscManagementService.getStudyFormLibraryData(
        "active",
        studyId
      );
      setFormLibraryList(data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const downloadTrialDesignTemplate = async () => {
    const csvContent = (libraryTemplate?.map(item => item?.name)).join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Form-Data-Template.csv";
    link.click();
  };

  useEffect(() => {
    if (studyId) getStudyFormLibraryData();
  }, [studyId]);

  const getStudyFormTemplatesData = async () => {
    if (!formId) return;
    try {
      setLoader(true);
      const data = await cdiscManagementService.getStudyFormTemplatesData(
        "active",
        studyId,
        formId
      );
      setFormLibraryTemplate(data?.data || []);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getStudyFormTemplatesData();
  }, [formId]);

  const getStudyDataEntry = async () => {
    try {
      setDataLoader(true);
      const data = await cdiscManagementService.getStudyDataEntry(
        studyId,
        formId,
        "",
        pageNumber,
        itemsPerPage
      );
      setStudyDataEntry(data?.data || []);
      setStudyDataEntryCount(data?.count || 0);
    } finally {
      setDataLoader(false);
    }
  };

  useEffect(() => {
    if (formId && studyId) {
      getStudyDataEntry();
    }
  }, [formId, pageNumber, itemsPerPage]);

  const deleteStudyDataEntry = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const userData = { id: id, studyId };
        cdiscManagementService.deleteStudyDataEntry(userData);
        getStudyFormTemplatesData();
        getStudyDataEntry();
      }
    });
  };

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        className="position-relative"
        style={{ height: "calc(100vh - 145px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : libraryList?.length === 0 ? (
          <NoDataFoundTable MSG={"Form library list not found!"} />
        ) : (
          <div className="p-2">
            <ListGroup>
              {libraryList.map((item, index) => (
                <ListGroup.Item
                  action
                  title={item?.label}
                  onClick={() => {
                    setFormId(item?.formId);
                    setPageNumber(1);
                  }}
                  key={item?._id || index}
                  className={`hstack justify-content-between p-0 ${
                    formId === item?.formId && "selectedMenu"
                  }`}
                >
                  <div style={{ padding: "5px 10px 7px 10px" }}>
                    <span>{item?.label} ({item?.name})</span>
                  </div>

                  <div
                    className="position-relative"
                    style={{ padding: "5px 10px 7px 10px" }}
                  >
                    <div
                      title="Add Data"
                      onClick={(e) => {
                        e.stopPropagation();
                        setFormId(item?.formId);
                        toggles.setToggle();
                      }}
                    >
                      <FaRegPlusSquare className="text-muted" />
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}

        {loader || dataLoader ? (
          <PageLoader />
        ) : !formId ? (
          <NoDataFoundTable MSG={"Select any library!"} />
        ) : (
          <>
            <div
              className="hstack justify-content-between border-bottom p-1 toolbar"
              style={{ height: 36 }}
            >
              <div className="hstack gap-2">
               <Form.Select onChange={(e) => setColumnBase(e.target.value)}>
                  <option selected={columnBase === "label"} value={`label`}>By Label</option>
                  <option selected={columnBase === "name"} value={`name`}>By Name</option>
               </Form.Select>
              </div>
              <button
                onClick={() => toggles.setToggle4()}
                className={`updateProfile`}
                style={{ fontSize: 12 }}
              >
                Import
              </button>
            </div>
            <SplitPane
              split="vertical"
              minSize={"100%"}
              className="position-relative"
              style={{ height: "calc(100vh - 183px)" }}
            >
              { studyDataEntryCount === 0 ? (
                <NoDataFoundTable MSG={"No Data Found!"} />
              ) : (
                <>
                  <Table
                    ref={tableRef}
                    className="m-0 custom-table w-auto"
                    hover
                    striped
                  >
                    <thead className="position-sticky top-0">
                      <tr>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 0)}
                          className="text-center"
                          style={{ width: 40 }}
                        >
                          Sr.
                        </th>
                        {libraryTemplate?.map((item, index) => (
                          <th
                            key={index}
                            onMouseDown={(e) => onMouseDown(e, index + 1)}
                          >
                            {columnBase === "label" ? item?.label : columnBase === "name" ? item?.name : ""}
                          </th>
                        ))}
                        <th>Updated By</th>
                        <th>Created Date | Time</th>
                        <th>Updated Date | Time</th>
                        <th className="text-center" style={{ width: 60 }}>
                          Edit
                        </th>
                        <th className="text-center" style={{ width: 60 }}>
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {studyDataEntry?.map((item, index) => (
                        <tr key={item._id || index}>
                          <td className="text-center">{startIndex + index + 1}</td>
                          {libraryTemplate.map((columnData, key) => (
                            <td key={key}>{item?.dataEntry?.[columnData?.name]}</td>
                          ))}
                          <td>{item?.updatedBy}</td>
                          <td>
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {item?.createdAt}
                            </Moment>
                          </td>
                          <td>
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {item?.updatedAt}
                            </Moment>
                          </td>
                          <td
                            className="text-center CP"
                            title={`Update ${item.name}`}
                            onClick={() => {
                              setTemplateData(item);
                              toggles.setToggle3();
                            }}
                          >
                            <FaEdit className="text-muted" />
                          </td>
                          <td
                            className="text-center CP"
                            title={`Delete ${item.name}`}
                            onClick={() => deleteStudyDataEntry(item?._id)}
                          >
                            <FaTrash className={"text-danger"} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div className="position-sticky bottom-0 start-0">
                    <Pagination
                      totalPage={totalPage}
                      pageNumber={pageNumber}
                      itemsPerPage={itemsPerPage}
                      totalItems={studyDataEntryCount}
                      setPageNumber={setPageNumber}
                      setItemsPerPage={setItemsPerPage}
                    />
                  </div>
                </>
              )}
            </SplitPane>
          </>
        )}
      </SplitPane>

      <AddFormLibrary
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        loader={loader}
        formId={formId}
        studyId={studyId}
        Title="Add Form Data"
        libraryTemplate={libraryTemplate}
        getStudyDataEntry={getStudyDataEntry}
        getStudyFormTemplatesData={getStudyFormTemplatesData}
      />

      <UpdateFormTemplate
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        formId={formId}
        studyId={studyId}
        Title="Update Form Data"
        templateData={templateData}
        libraryTemplate={libraryTemplate}
        getStudyDataEntry={getStudyDataEntry}
        getStudyFormTemplatesData={getStudyFormTemplatesData}
      />
      <ImportFormColumnData
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        formId={formId}
        studyId={studyId}
        Title={"Import Form Column Data"}
        getStudyFormTemplatesData={getStudyFormTemplatesData}
        downloadTrialDesignTemplate={downloadTrialDesignTemplate}
      />
    </>
  );
};

export default FormDataManagement;
